module.exports = __webpack_public_path__ + "static/media/short-legends-never-die.159dd3d8.mp3";